import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAsset } from '../../../types/fleet';
import { getAssetTitle } from '../../../utils/assets';
import { FleetAssetForm } from './FleetAssetForm';

type Props = {
  isOpen: boolean;
  selectedAsset: FleetAsset;
  onClose: (update?: boolean) => void;
};

function FleetAssetModal({ onClose, isOpen, selectedAsset }: Props) {
  const { css } = useStyles();
  const assetLabel = `${getAssetTitle(selectedAsset)} (${selectedAsset.label})`;

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
            maxWidth: '560px',
          })}
        >
          {assetLabel}
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          <FleetAssetForm
            asset={selectedAsset}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetAssetModal);
